import React from 'react';
import { NavLink } from 'react-router-dom';

var bnr1 = require('./../../images/background/bg-6.png');

class Specialization3 extends React.Component {
    render() {
        return (
            <>
                <div className="section-full p-t80 p-b50 bg-dark mobile-page-padding" style={{backgroundImage:"url(" + bnr1 + ")"}}>
                    <div className="container">
                        {/* IMAGE CAROUSEL START */}
                        <div className="section-content">
                            <div className="section-head m-b50 text-white text-center">
                                <h3 className="m-t0">Your Trusted Partner in MEP Services.</h3>
                                <p>From the smallest extinguisher to complete sprinkler and alarm systems, we provide end-to-end fire and security solutions. With AMC and 24/7 support, you’re never alone when safety’s on the line.</p>
                            </div>
                            <div className="row">
                                <div className="col-md-4 col-sm-6 m-b30">
                                    <div className="image-effect-one hover-shadow">
                                        <img src={require('../../images/services/new1.jpg')}  alt=""/>
                               <div className="figcaption">
                                            <h4>HVAC Duct Work</h4>
                                            <p>Built to move air, engineered for comfort.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4 col-sm-6 m-b30">
                                    <div className="image-effect-one hover-shadow">
                                        <img src={require('../../images/services/main-pic-1.jpg')} alt="" />
                                        <div className="figcaption">
                                            <h4>Chilling Water Pipeline</h4>
                                            <p>Precision-engineered pipelines for efficient cooling.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4 col-sm-12 m-b30">
                                    <div className="image-effect-one hover-shadow">
                                        <img src={require('../../images/services/main-v3.jpg')} alt=""/>
                                        <div className="figcaption bg-dark">
                                            <h4>Annual Maintenance</h4>
                                            <p>We don’t just install—we protect for life.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
};

export default Specialization3;